
















































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import {
  getUser,
  createUser,
  updateUser,
  checkInformationExists,
} from '@/api/index';

const UserEditor = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  props: {
    edit: {
      default() { return false; },
    },
    initRole: {
      default() { return -1; },
    },
  },
  setup(props: any) {
    const { route } = useRouter();

    const oldInformation = reactive({
      email: '',
      telephone: '',
    });

    const successModal = ref(null);
    const form = reactive({
      name: '',
      email: '',
      telephone: '',
      password: '',
      organization: '',
      online: false,
      admin: true,
      employeeCode: '',
      pdpaConsent: true,
      call: async () => {
        if (props.edit === true) {
          const result = await updateUser(
            route.value.params.userId,
            form.name,
            form.email,
            form.telephone,
            form.organization,
            false,
            form.password,
            form.admin,
            form.employeeCode,
          );
        } else {
          const result = await createUser(
            form.name,
            form.email,
            form.telephone,
            form.organization,
            false,
            [props.initRole],
            form.admin,
            form.employeeCode,
            form.password,
          );
        }
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
      state: {
        value: 'READY',
      },
    });

    onMounted(async () => {
      if (route.value.params.userId) {
        const { user } = await getUser(route.value.params.userId);
        form.name = user.name;
        form.email = user.email;
        form.telephone = user.telephone;
        form.organization = user.organization;
        form.online = user.online;
        form.employeeCode = user.employeeCode;

        oldInformation.email = user.email;
        oldInformation.telephone = user.telephone;
      }
    });

    const telephoneValidationRules = reactive({
      required: true,
      regex: /^((\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}|(\+(\d{11})))$/,
      excluded: [],
    });
    const failedValidatedEmailRule = ref('');
    const checkInformationHandler = _.debounce(async () => {
      const result = await checkInformationExists(
        form.email,
        form.telephone,
      );

      if (result.telephone === true && ((props.edit && oldInformation.telephone !== form.telephone) || !props.edit)) (telephoneValidationRules.excluded as any).push(form.telephone);
      else (telephoneValidationRules.excluded as any) = [];

      if (result.email && ((props.edit && oldInformation.email !== form.email) || !props.edit)) failedValidatedEmailRule.value = `excluded:${form.email}`;
      else failedValidatedEmailRule.value = '';
    }, 500);

    return {
      successModal,
      form,

      telephoneValidationRules,
      failedValidatedEmailRule,
      checkInformationHandler,
    };
  },
});

export default UserEditor;
